<div class="recipient-header-checkbox">
    <sol-checkbox class="recipient-checkbox" [checked]="checked" (checkedChange)="onCheckboxChange($event)"
    [indeterminate]="indeterminate"></sol-checkbox>
    <span class="checkbox-header-text">{{ params.displayName }}</span>
</div>